<template>
  <div :style="{ width: width + 'px' }">
    <form-field-label :required="required">{{ schema.label }}</form-field-label>
    <div class="viper-text-field-value">
      <form-field-value v-if="formOptions.readonly" :value="value"></form-field-value>
      <v-autocomplete
        v-else
        v-model="model[schema.model]"
        single-line
        outlined
        clearable
        :multiple="schema.multiple"
        :items="sortedItems"
        :loading="loading"
        item-text="value"
        item-value="id"
        class="viper-outline-input"
        :error-messages="errorMessages"
        @input="triggerValidation"
        @blur="triggerValidation"
      >
        <template v-if="schema.multiple" #selection="data">
          <v-chip
            v-model="data.selected"
            close
            class="chip--select-multi"
            @update:active="remove(data.item)"
          >
            {{ data.item.value }}
          </v-chip>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import FormFieldMixin from '@/components/form-fields/FormFieldMixin'
import _ from 'lodash'
import FormFieldLabel from '@/components/form-fields/FormFieldLabel'
import FormFieldValue from '@/components/form-fields/FormFieldValue'

export default {
  components: { FormFieldValue, FormFieldLabel },
  mixins: [FormFieldMixin],
  props: {
    items: { type: Array, required: true },
    options: { type: Array, required: true }
  },
  computed: {
    loading() {
      return _.isEmpty(this.items)
    },
    sortedItems() {
      if (_.has(this.schema, 'order.desc') && _.has(this.schema, 'order.sortBy')) {
        if (this.schema.order.desc.toLowerCase() === 'true') {
          return _.sortBy(this.items, [this.schema.order.sortBy]).reverse()
        } else {
          return _.sortBy(this.items, [this.schema.order.sortBy])
        }
      }
      return this.items
    },
    value() {
      let value = this.model[this.schema.model]
      if (value instanceof Array) {
        const values = _.map(value, v => {
          const option = _.find(this.options, { id: v })
          return option ? option.value : null
        })
        return values.join(', ')
      }
      let fieldOption = _.find(this.options, { id: value })
      return fieldOption ? fieldOption.value : null
    }
  },
  methods: {
    remove(item) {
      const index = this.model[this.schema.model].indexOf(item.id)
      if (index >= 0) {
        this.model[this.schema.model].splice(index, 1)
      }
    }
  }
}
</script>
